import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function listFeedbackFollowups(params = {}, token) {
  const res = await axios.get(`${API}/marketing/feedback-followups`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getFeedbackFollowup(followupId, token) {
  const res = await axios.get(
    `${API}/marketing/feedback-followups/${followupId}`,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function assignFeedbackFollowup(followupId, payload, token) {
  const res = await axios.post(
    `${API}/marketing/feedback-followups/${followupId}/assign`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function updateFeedbackFollowupStatus(followupId, payload, token) {
  const res = await axios.post(
    `${API}/marketing/feedback-followups/${followupId}/status`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function addFeedbackFollowupNote(followupId, payload, token) {
  const res = await axios.post(
    `${API}/marketing/feedback-followups/${followupId}/notes`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function sendFeedbackFollowupEmail(followupId, payload, token) {
  const res = await axios.post(
    `${API}/marketing/feedback-followups/${followupId}/send-email`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function listFeedbackTemplates(salonId, token, params = {}) {
  const res = await axios.get(`${API}/marketing/feedback-templates`, {
    params: { salon_id: salonId, ...params },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createFeedbackTemplate(salonId, payload, token) {
  const res = await axios.post(`${API}/marketing/feedback-templates`, payload, {
    params: { salon_id: salonId },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateFeedbackTemplate(templateId, payload, token) {
  const res = await axios.put(
    `${API}/marketing/feedback-templates/${templateId}`,
    payload,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function deleteFeedbackTemplate(templateId, token) {
  const res = await axios.delete(
    `${API}/marketing/feedback-templates/${templateId}`,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function updateFeedbackTags(reviewId, payload, token) {
  const res = await axios.post(`${API}/marketing/feedback/${reviewId}/tags`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}
